import React, { Component } from 'react';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import MoreVertSharpIcon from "@material-ui/icons/MoreVertSharp";

import { getCookie, getDate } from '../../function';
import CircularLoader from '../circular-loader/CircularLoader';
import SendGroupToLMS from '../send-to-lms-modal/send-to-lms-modal';

export default class Department extends Component {
    constructor(props) {
        super(props);
        this.isTASyncing = getCookie('isTASyncing');
        this.isTAconnected = getCookie('isTAconnected');
        this.state = {
            showModal: false,
        }
    }
    

    handleAction = () => {
        this.props.setShow(true);
        this.props.setSelectedGroupId(this.props.group.id);
        this.props.setCustomGroupName(this.props.group.name);
        this.props.setSelectedGroupType(this.props.group.type);
    }
    hideModal = () => {
        this.setState({showModal: false})
    }

    render() {
        const group = this.props.group;
        return (
            <tbody>
                <tr>

                    <td className="onlyForPinter" style={{ cursor: "pointer" }} onClick={this.handleAction}>
                        <div className="flexTableData">
                            <div className="circle">
                                <p className="circle-inner">{(group?.name && group.name[0])}</p>
                            </div>
                            <div>
                                <h6>
                                    {group && group.name?.startsWith("ALL-Users-IN-COMPANY-") ? "all-users-tsat" : (group.name?.startsWith("All-Members-Group_CompanyId_") ? "all-users-tsat(LMS)" : group.name)}
                                </h6>

                            </div>
                        </div>
                    </td>
                    <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: "8px" }}>
                            {group?.targets}
                            {group.status === "pending" && group.totalMembersToSync &&
                                <CircularLoader percentage={Math.floor(group.syncedRecords * 100 / group.totalMembersToSync)} />
                            }
                        </div>
                    </td>
                    <td>
                        {getDate(group?.createdAt)}
                    </td>
                    <td>
                        {getDate(group?.updatedAt)}
                    </td>
                    <td>
                        <Dropdown
                            className="action-dropdown dropdownIcon" ref={this.selectRef}>
                            <Dropdown.Toggle className="btn-only" id="dropdown-basic">
                                <MoreVertSharpIcon className="dot-icon"></MoreVertSharpIcon>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={this.handleAction}>{(group && group.name && (group?.name?.startsWith("ALL-Users-IN-COMPANY-") || group?.name === "Individual-Users" || this.props.groupType === "admin" || !this.props.permissibleActionsIAM['user-and-department-write']) ? "View" : "Edit")}</Dropdown.Item>
                                {(group && group.name && !group.name.startsWith("ALL-Users-IN-COMPANY-") && group?.name !== "Individual-Users" && this.props.groupType === "custom")
                                    &&
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            this.isTASyncing ? (
                                                <Tooltip id="top"> <span>Threatcop Admin Sync is already in progress</span>
                                                </Tooltip>
                                            ) : (
                                                (!this.props.permissibleActionsIAM['user-and-department-delete']?(
                                                    <Tooltip id="top"> <span>You don't have permission to delete users & groups</span>
                                                    </Tooltip>
                                                ):(
                                                    <Tooltip id="top" className="d-none" />
                                                ))
                                            )
                                        }
                                    >
                                        <Dropdown.Item className={`${this.isTASyncing && 'disabledCls3'}`} onClick={e => {if(!this.isTASyncing && this.props.permissibleActionsIAM['user-and-department-delete']) return this.props.handleDeleteGroup(this.props.group.id)}}>Delete</Dropdown.Item>
                                    </OverlayTrigger>
                                }
                                {this.isTAconnected && this.props.groupType === "custom" && !group.name.startsWith("ALL-Users-IN-COMPANY-") &&
                                    <Dropdown.Item onClick={e => {if(this.props.permissibleActionsIAM['user-and-department-write']) return this.setState({showModal: true})}}>Send to LMS</Dropdown.Item>
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                    </td>
                </tr>
                <SendGroupToLMS 
                    showModal={this.state.showModal}
                    hideModal={this.hideModal}
                    groupId={this.props.group.id}
                    sendGroupToLMS={this.props.sendGroupToLMS}
                />
            </tbody>
        )
    }
}